import React, { useState,useRef } from 'react';
import { useEffect } from 'react';
import { FormHeader,  ErrorSummary, ContentContainer, Row, Col, Button, RadioButtonList, tokens,pxToRem,InPageAlert,TextLink } from '@snsw-gel/react';
import { dataLayer } from '../../services/gtm-dataLayer';
import { useHistory } from 'react-router-dom';
import styles from './BeforeYouStart.module.scss';

const BeforeYouStart = () => {
    const [hasExistingCard, setHasExistingCard] = useState(null);
    const [error, setError] = useState(false);
    const history = useHistory();
    const errorSummaryRef = useRef(null);

    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = 'Before you start';
        dataLayer(currentUrl, pageName);
    }, []);

    useEffect(() => {
        if (errorSummaryRef.current) {
            errorSummaryRef.current.focus();
        }
    }, [error]);

    const onChangeEvent = v => {
        setHasExistingCard(v);
    };

    const onSubmitPage = () => {
        setError(false);
        if (hasExistingCard === null) {
            setError(true);
            return;
        }
        if (hasExistingCard === 'true') {
            localStorage.setItem('soFlow', 'link');
            window.location.href = process.env.REACT_APP_SERVICE_ORCHESTRATOR_LINKING_URL;
        } else if (hasExistingCard === 'false') {
            history.push('/eligibilityCheck')
        }
    };

    return (
        <>
            <FormHeader
                label='Apply for a NSW Seniors Card or NSW Senior Savers Card '
                title='Before you start'
            />
            <ContentContainer className={styles['content-container']}>
                <Row>
                    <Col span={6}>
                        {error &&
                            <ErrorSummary
                             ref={errorSummaryRef}
                             errors={[{ id: 'hasExistingCard-0', text: 'Select an option to continue.' }]}
                              />}


                        <RadioButtonList
                            id='hasExistingCard'
                            name='hasExistingCard'
                            legend='Do you already have a NSW Seniors Card or NSW Senior Savers Card?'
                            vertical={true}
                            options={[
                                { value: 'false', label: 'No' },
                                { value: 'true', label: 'Yes' },
                            ]}
                            onChange={onChangeEvent}
                            aria-label="required"
                            hasError={error}
                            errorMessage='Select an option to continue.'
                            value={hasExistingCard}
                        />
                        <InPageAlert variant='info' title='Note.' compact>
                            <p>To add your existing card to your MyServiceNSW Account, you need your card number. </p>
                        </InPageAlert>

                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Button
                            className={styles['continue-button']}
                            id='applyButton'
                            onClick={onSubmitPage}
                        >
                            Continue
                        </Button>
                    </Col>
                </Row>

                <Row>
                    <Col span={12}>
                        <Button
                            className={styles['back-link']}
                            variant="link"
                            as={TextLink}
                            href='https://www.service.nsw.gov.au/preview-link/node/638/25e4a494-a4a9-43cf-9755-c5dd141fb045'
                            aria-label='Go back'
                        >
                            Back
                        </Button>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );
};

export default BeforeYouStart;

